import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import { AiOutlineHome } from "react-icons/ai";
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import PortfolioFrame from '../components/PortfolioFrame';

const NotFoundPage = () => {
    return (
        <PortfolioFrame>
            <Grid container alignItems="center" justifyContent="center" style={{color: "#d3d3d3"}}>
                <Grid item container justifyContent="center" xs={12}>
                    <Typography variant="h4" align="center">Esta página no está disponible</Typography>
                </Grid>
                <Grid item container justifyContent="center">
                    <Link component={RouterLink} to="/projects" color="inherit">
                        <IconButton 
                            className="icon-button" 
                            title="Principal" 
                            color="inherit"
                            style={{ background: "#d3d3d320" }}
                            >
                            <AiOutlineHome size={"1.5em"} />
                        </IconButton>
                    </Link>
                </Grid>
            </Grid>
        </PortfolioFrame>
    );
}

export default NotFoundPage;